var t=function(t){return null!=t&&"object"==typeof t};export{t as i};
//# sourceMappingURL=isObjectLike.js.map
